// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"126":"5cf21b90","334":"ca6c4501"}[chunkId] + ".css";
};